import { useEffect, useState } from 'react';
import { HiOutlineUsers } from "react-icons/hi2";
import { useLocation } from 'react-router-dom';
import { PiEnvelopeSimple } from "react-icons/pi";
import { PiMotorcycleFill } from "react-icons/pi"
import { PiHouse } from "react-icons/pi";
import { HiOutlineQrCode } from "react-icons/hi2";


function NavBar() {

    const roll = parseInt(localStorage.getItem('userRoll'))

    // Estado para controlar si estamos en desktop o mobile
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

    // Obtener la altura del header para calcular la posición del navbar
    const [headerHeight, setHeaderHeight] = useState(0);

    const location = useLocation();
    const [isActiveHome, setIsActiveHome] = useState(false);
    const [isActiveQR, setIsActiveQR] = useState(false);
    const [isActiveUsers, setIsActiveUsers] = useState(false);
    const [isActiveUsersList, setIsActiveUsersList] = useState(false);
    const [isActiveParking, setIsActiveParking] = useState(false);
    const [isActiveTickets, setIsActiveTickets] = useState(false);
    const [isActiveCreateUserEmployee, setIsActiveCreateUserEmployee] = useState(false);
    const [isActiveAprendizRequest, setIsActiveAprendizRequest] = useState(false);

    useEffect(() => {
        setIsActiveHome(location.pathname === '/home');
        setIsActiveUsers(location.pathname === '/users-administration');
        setIsActiveUsersList(location.pathname === '/users-administration-list');
        setIsActiveQR(location.pathname === '/qr-generator');
        setIsActiveParking(location.pathname === '/dashboard');
        setIsActiveTickets(location.pathname === '/TicketsTable');
        setIsActiveCreateUserEmployee(location.pathname === '/user-registration-employees');
        setIsActiveAprendizRequest(location.pathname === '/user-registration-request');
        
    }, [location]);

    // Listener para cambios de tamaño de pantalla y obtener la altura del header
    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth >= 768);
            
            // Obtener la altura del header
            const headerElement = document.querySelector('[data-testid="logged-layout-header"]');
            if (headerElement) {
                setHeaderHeight(headerElement.clientHeight);
            }
        };

        // Ejecutar inmediatamente para obtener la altura inicial
        handleResize();

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Clases para el contenedor principal dependiendo si es mobile o desktop
    const containerClasses = isDesktop 
        ? "fixed left-0 top-0 h-screen z-40 flex items-center pt-[80px]" 
        : "fixed bottom-0 z-50 w-full";

    // Clases para el navbar interior dependiendo si es mobile o desktop
    const navbarClasses = isDesktop 
        ? "h-[75vh] py-8 mx-4 my-auto bg-gradient-to-r from-amber-600 to-amber-800 backdrop-blur-sm border-r border-amber-700 shadow-lg rounded-xl" 
        : "px-4 py-2 bg-gradient-to-t from-amber-600 to-amber-800 backdrop-blur-sm border-t border-amber-700 shadow-lg rounded-t-xl";

    // Clases para el contenedor de los botones dependiendo si es mobile o desktop
    const buttonContainerClasses = isDesktop 
        ? "flex flex-col justify-between items-center w-full h-full py-8" 
        : "flex flex-row justify-around items-center w-full";

    // Estilo específico de posicionamiento para desktop para colocarlo debajo del header
    const desktopPositionStyle = isDesktop ? {
        top: `${headerHeight}px`,
        height: `calc(100vh - ${headerHeight}px)`
    } : {};

  return (
    <div className={containerClasses} style={desktopPositionStyle} data-testid="navbar">
      <div className={isDesktop ? "h-full" : "w-full mx-auto max-w-screen-2xl"}>
        <div className={navbarClasses}>
          <div className={buttonContainerClasses}>
            
            {/* Home Link */}
            <div className={`group ${isActiveHome ? 'text-purple-700' : 'text-black'}`} data-testid="navbar-home">
              <a href="/home" className="flex flex-col items-center justify-center text-center px-3 py-1 group-hover:text-purple-600 transition-all duration-300 ease-in-out">
                <div className="relative">
                  <div className="flex justify-center text-2xl md:text-3xl transition-all duration-300 ease-in-out group-hover:scale-110 group-hover:-translate-y-1" data-testid="navbar-icon">
                    <PiHouse />
                  </div>
                  {isActiveHome && (
                    <span className={`absolute ${isDesktop ? '-right-1 -top-1' : '-top-1 -right-1'} w-2 h-2 bg-purple-600 rounded-full`}></span>
                  )}
                </div>
                <span className="block text-xs md:text-sm font-medium mt-1" data-testid="navbar-title">Home</span>
                <div className={`${isDesktop ? 'w-0.5 h-full ml-1' : 'w-full h-0.5 mt-1'} rounded-full transition-all duration-300 ${isActiveHome ? 'bg-purple-700 ' + (isDesktop ? 'h-full' : 'w-full') : (isDesktop ? 'h-0 group-hover:h-full' : 'w-0 group-hover:w-full') + ' group-hover:bg-purple-600/50'}`} data-testid="navbar-indicator"></div>
              </a>
            </div>
            
            {/* QR or Users Link based on roll */}
            <div className="group" data-testid="navbar-qr">
              {roll === 2 && (
                <a href="/qr-generator?show=true" className={`flex flex-col items-center justify-center text-center px-3 py-1 ${isActiveQR ? 'text-purple-700' : 'text-black'} group-hover:text-purple-600 transition-all duration-300 ease-in-out`}>
                  <div className="relative">
                    <div className="flex justify-center text-2xl md:text-3xl transition-all duration-300 ease-in-out group-hover:scale-110 group-hover:-translate-y-1" data-testid="navbar-icon">
                      <HiOutlineQrCode />
                    </div>
                    {isActiveQR && (
                      <span className={`absolute ${isDesktop ? '-right-1 -top-1' : '-top-1 -right-1'} w-2 h-2 bg-purple-600 rounded-full`}></span>
                    )}
                  </div>
                  <span className="block text-xs md:text-sm font-medium mt-1" data-testid="navbar-title">QR</span>
                  <div className={`${isDesktop ? 'w-0.5 h-full ml-1' : 'w-full h-0.5 mt-1'} rounded-full transition-all duration-300 ${isActiveQR ? 'bg-purple-700 ' + (isDesktop ? 'h-full' : 'w-full') : (isDesktop ? 'h-0 group-hover:h-full' : 'w-0 group-hover:w-full') + ' group-hover:bg-purple-600/50'}`} data-testid="navbar-indicator"></div>
                </a>
              )}
              {(roll === 1 || roll === 3) && (
                <a href="/users-administration" className={`flex flex-col items-center justify-center text-center px-3 py-1 ${isActiveUsers || isActiveUsersList || isActiveCreateUserEmployee || isActiveAprendizRequest ? 'text-purple-700' : 'text-black'} group-hover:text-purple-600 transition-all duration-300 ease-in-out`}>
                  <div className="relative">
                    <div className="flex justify-center text-2xl md:text-3xl transition-all duration-300 ease-in-out group-hover:scale-110 group-hover:-translate-y-1" data-testid="navbar-icon">
                      <HiOutlineUsers />
                    </div>
                    {(isActiveUsers || isActiveUsersList || isActiveCreateUserEmployee || isActiveAprendizRequest) && (
                      <span className={`absolute ${isDesktop ? '-right-1 -top-1' : '-top-1 -right-1'} w-2 h-2 bg-purple-600 rounded-full`}></span>
                    )}
                  </div>
                  <span className="block text-xs md:text-sm font-medium mt-1" data-testid="navbar-title">Usuarios</span>
                  <div className={`${isDesktop ? 'w-0.5 h-full ml-1' : 'w-full h-0.5 mt-1'} rounded-full transition-all duration-300 ${isActiveUsers || isActiveUsersList || isActiveCreateUserEmployee || isActiveAprendizRequest ? 'bg-purple-700 ' + (isDesktop ? 'h-full' : 'w-full') : (isDesktop ? 'h-0 group-hover:h-full' : 'w-0 group-hover:w-full') + ' group-hover:bg-purple-600/50'}`} data-testid="navbar-indicator"></div>
                </a>
              )}
            </div>
            
            {/* Parking Link */}
            <div className="group" data-testid="navbar-parking">
              <a href="/dashboard" className={`flex flex-col items-center justify-center text-center px-3 py-1 ${isActiveParking ? 'text-purple-700' : 'text-black'} group-hover:text-purple-600 transition-all duration-300 ease-in-out`}>
                <div className="relative">
                  <div className="flex justify-center text-2xl md:text-3xl transition-all duration-300 ease-in-out group-hover:scale-110 group-hover:-translate-y-1" data-testid="navbar-icon">
                    <PiMotorcycleFill />
                  </div>
                  {isActiveParking && (
                    <span className={`absolute ${isDesktop ? '-right-1 -top-1' : '-top-1 -right-1'} w-2 h-2 bg-purple-600 rounded-full`}></span>
                  )}
                </div>
                <span className="block text-xs md:text-sm font-medium mt-1" data-testid="navbar-title">Parking</span>
                <div className={`${isDesktop ? 'w-0.5 h-full ml-1' : 'w-full h-0.5 mt-1'} rounded-full transition-all duration-300 ${isActiveParking ? 'bg-purple-700 ' + (isDesktop ? 'h-full' : 'w-full') : (isDesktop ? 'h-0 group-hover:h-full' : 'w-0 group-hover:w-full') + ' group-hover:bg-purple-600/50'}`} data-testid="navbar-indicator"></div>
              </a>
            </div>
            
            {/* Tickets Link */}
            <div className="group" data-testid="navbar-tickets">
              <a href="/TicketsTable" className={`flex flex-col items-center justify-center text-center px-3 py-1 ${isActiveTickets ? 'text-purple-700' : 'text-black'} group-hover:text-purple-600 transition-all duration-300 ease-in-out`}>
                <div className="relative">
                  <div className="flex justify-center text-2xl md:text-3xl transition-all duration-300 ease-in-out group-hover:scale-110 group-hover:-translate-y-1" data-testid="navbar-icon">
                    <PiEnvelopeSimple />
                  </div>
                  {isActiveTickets && (
                    <span className={`absolute ${isDesktop ? '-right-1 -top-1' : '-top-1 -right-1'} w-2 h-2 bg-purple-600 rounded-full`}></span>
                  )}
                </div>
                <span className="block text-xs md:text-sm font-medium mt-1" data-testid="navbar-title">Tickets</span>
                <div className={`${isDesktop ? 'w-0.5 h-full ml-1' : 'w-full h-0.5 mt-1'} rounded-full transition-all duration-300 ${isActiveTickets ? 'bg-purple-700 ' + (isDesktop ? 'h-full' : 'w-full') : (isDesktop ? 'h-0 group-hover:h-full' : 'w-0 group-hover:w-full') + ' group-hover:bg-purple-600/50'}`} data-testid="navbar-indicator"></div>
              </a>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default NavBar;
